import { useState } from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
} from '@mui/material';

import {
  useGetAuthenticationQuery,
  useGetAuthKeyQuery,
} from '../../services/ADapi';

import { TableHeadCell, TableBodyCell } from '../table-cells/TableCells';
import DeleteAuthKeyDialog from './RemoveAuthKey';
import Icon from '../Icon';

const AuthKeyView = () => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();
  const [isDialogShow, setDialogState] = useState(false);

  const dialogStateHandler = () => {
    setDialogState((prevState) => !prevState);
  };

  const { data: authKey } = useGetAuthKeyQuery(user_id);

  return (
    <>
      <TableContainer sx={{ pb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeadCell>Keys</TableHeadCell>
              <TableHeadCell>Base 64</TableHeadCell>
              <TableHeadCell>Created</TableHeadCell>
              <TableHeadCell>Status</TableHeadCell>
              <TableHeadCell></TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableBodyCell scope="row">{authKey.auth_key}</TableBodyCell>
              <TableBodyCell>{authKey.auth_key}</TableBodyCell>
              <TableBodyCell>{authKey.updated}</TableBodyCell>
              <TableBodyCell>
                <Typography
                  variant="caption"
                  sx={{
                    p: '4px 10px',
                    backgroundColor: 'success.light',
                    borderRadius: '6px',
                  }}
                >
                  Active
                </Typography>
              </TableBodyCell>
              <TableBodyCell sx={{ width: '72px' }}>
                <IconButton onClick={dialogStateHandler}>
                  <Icon id="delete" />
                </IconButton>
              </TableBodyCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {isDialogShow ? (
        <DeleteAuthKeyDialog
          isDialogShow={isDialogShow}
          onDialogAction={dialogStateHandler}
        />
      ) : null}
    </>
  );
};

export default AuthKeyView;
